import { ExpandMore } from "@mui/icons-material";
import { createTheme } from '@mui/material/styles';

const themeConfig = (mode = "light") => {
    const darkMode = mode === "dark"
    const theme = createTheme({
        components: {
            MuiAutocomplete: {
                defaultProps: {
                    popupIcon: <ExpandMore />
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: "8px",
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        '& .MuiOutlinedInput-root': {
                            borderRadius: "12px",
                        },
                    },
                },
            },
        },
        typography: {
            fontFamily: "Poppins, Roboto, Helvetica, Arial, sans-serif, Montserrat",
            button: {
                textTransform: 'unset', // Set textTransform to 'unset' for buttons
            },
            "subtitle1": {
                fontWeight: 600,
                fontSize: "18px",
                lineHeight: "32px",
            },
            "subtitle2": {
                fontWeight: 600,
                fontSize: "16px",
                lineHeight: "32px",
            },
            "title1": {
                fontWeight: 600,
                fontSize: '28px',
                lineHeight: '57px'
            }
        },
        palette: {
            mode,
            text: {
                primary: darkMode ? `rgba(255,255,255,0.87)` : `rgba(0,0,0,0.87)`
            },
            background: {
                default: darkMode ? "#121212" : "#F8F8FA",
                paper: darkMode ? "#212121" : "#fff",
                // default background colors start
                primary: darkMode ? "#2A3B4F" : "#DDEAF8",
                secondary: "#EADAF8",
                success: "#cce6cc",
                info: darkMode ? "#2A3B4F" : "#DDEAF8",
                warning: "#FFE5CC",
                error: "#F7D9D9",
                // default background colors end
                yellow: "#FFF9DB",
                grey: "#D9DBE3",
                blue: "#D0E8FF"

            },
            blue: {
                1: "#2D2FA9",
                2: darkMode ? "#90caf93d" : "#1976d21f",
                3: "#4D48B3",
                4: "#528ED8",
                5: "#1E2A51",
                6: darkMode ? "#43516F" : "#2F5199",
                7: "#94bdef",
                8: "#1976D2",
                9: "#E7EEFF"
            },
            yellow: {
                1: "#FFB119",
                2: "#FFEEBA",
            },
            orange: {
                1: "#EB5816",
                2: "#EF8934",
                3: "#FFD8C6",
            },
            purple: {
                1: "#6D30BC"
            },
            green: {
                1: "#008000"
            },
            grey: {
                1: "#515869"
            },
            red: {
                1: "#CC0000"
            }
        },
    });
    return theme;
}

export default themeConfig